// src/modules/app-views/crm/pages/Boards/modals/QuickCaptureModal/Step1Contact.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Col, Row } from 'antd';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleTextArea from 'components/SimpleComponents/SimpleTextArea';
import SimplePhone from 'components/SimpleComponents/SimplePhone';
import SimpleEmail from 'components/SimpleComponents/SimpleEmail';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const Step1Contact = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="p-2">
      <Row gutter={16}>
        <Col xs={24} sm={16}>
          <SimpleInput
            name="name"
            label="name"
            required
          />
        </Col>
        <Col xs={24} sm={8}>
          <SimpleInput
            name="role"
            label="role"
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <SimpleInput
            name="company"
            label="company"
          />
        </Col>
        <Col xs={24} sm={12}>
          <SimpleInput
            name="sector"
            label="sector"
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <SimplePhone
            name={['phone', 'value']}
            label="phone"
            international
          />
        </Col>
        <Col xs={24} sm={12}>
          <SimpleEmail
            name={['email', 'value']}
            label="email"
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24}>
          <SimpleTextArea
            name="note"
            label="note"
            rows={2}
          />
        </Col>
      </Row>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default Step1Contact;
